module.exports = __webpack_public_path__ + "static/media/wDark_cloudy.5def7d71.svg";